(function() {

  var svgContainer = $('.svg-random');
  var svgId = $('.svg-random path').attr('id');


  $(svgContainer).each(function () {
      var suffix = Math.floor(Math.random() * 1000);
      $(this).children('path').attr('id', svgId + '-' + suffix);    
  });
  
})();

